import { render } from "./EditFolderSidebar.vue?vue&type=template&id=583cc010&ts=true"
import script from "./EditFolderSidebar.vue?vue&type=script&lang=ts"
export * from "./EditFolderSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__